<div class="share-section">
    <div class="share-option">
      <div class="share-header">
        <span>Share as link</span>
        <button mat-icon-button class="help-button">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
      <div class="share-content">
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [value]="shareLink" readonly>
        </mat-form-field>
        <button mat-stroked-button (click)="copyToClipboard(shareLink)">
          <mat-icon>content_copy</mat-icon> Copy to clipboard
        </button>
      </div>
    </div>
    
    <!-- <div class="share-option">
      <div class="share-header">
        <span>Add to email</span>
        <button mat-icon-button class="help-button">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
      <div class="share-content">
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput [value]="embedCode" rows="4" readonly></textarea>
        </mat-form-field>
        <button mat-stroked-button (click)="copyToClipboard(embedCode)">
          <mat-icon>content_copy</mat-icon> Copy to clipboard
        </button>
      </div>
    </div> -->
    
    <div class="share-option">
      <div class="share-header">
        <span>Embed on your website</span>
        <button mat-icon-button class="help-button">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
      <div class="share-content">
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput [value]="iframeCode" rows="4" readonly></textarea>
        </mat-form-field>
        <button mat-stroked-button (click)="copyToClipboard(iframeCode)">
          <mat-icon>content_copy</mat-icon> Copy to clipboard
        </button>
      </div>
    </div>
  </div>